export const INVALID_RESPONSE_FORMAT_ERROR = 'Invalid response format';
export const UNEXPECTED_ERROR = 'Unexpected error';
export const ENROLLMENT_COMPONENT_NOT_FOUND = 'Enrollment component not found';
